module.exports = __webpack_public_path__ + "static/media/localeur_dining.3c0a3328.jpg";